import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/consultation/page.tsx");
